module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./bower_components/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2
 ** module id = 200
 ** module chunks = 1
 **/